import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const BarCode: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'bar-code'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        {...props}>
        <path
          d="M1.3335 2.66675H2.66683V13.3334H1.3335V2.66675ZM4.00016 2.66675H5.3335V13.3334H4.00016V2.66675ZM6.00016 2.66675H8.00016V13.3334H6.00016V2.66675ZM8.66683 2.66675H10.0002V13.3334H8.66683V2.66675ZM10.6668 2.66675H12.0002V13.3334H10.6668V2.66675ZM12.6668 2.66675H14.6668V13.3334H12.6668V2.66675Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default BarCode
